import React from 'react';
import styled, { css } from '@emotion/native';
import {
  StyleProp,
  TextStyle,
  TouchableOpacity,
  ViewStyle,
  ImageStyle,
} from 'react-native';
import { green, white } from '@/shared/styles/colors';
import { BaseText, LoraText } from './StyledText';
import { selectButtonDescriptions } from '../constants/client-onboarding';

interface PreferenceButtonProps {
  item: string;
  isSelected: boolean;
  isDesktop: boolean;
  onToggle: (item: string) => void;
  buttonStyle?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
  checkStyle?: StyleProp<ImageStyle>;
  showDescription?: boolean;
}

const PreferenceButton: React.FC<PreferenceButtonProps> = ({
  item,
  isSelected,
  isDesktop,
  onToggle,
  buttonStyle,
  textStyle,
  checkStyle,
  showDescription = false,
}) => {
  const buttonHeight = showDescription ? 106 : isDesktop ? 81 : 72;
  return (
    <CustomTouchableOpacity
      isSelected={isSelected}
      isDesktop={isDesktop}
      onPress={() => onToggle(item)}
      style={buttonStyle ?? {}}
      height={buttonHeight}
    >
      {isSelected && (
        <Check
          source={require('@/assets/images/SmallCheckMark.png')}
          style={checkStyle ?? {}}
        />
      )}
      <CustomText
        isDesktop={isDesktop}
        selected={isSelected}
        allowFontScaling={false}
        style={textStyle ?? {}}
      >
        {item}
      </CustomText>
      {showDescription && (
        <DescriptionText selected={isSelected} allowFontScaling={false}>
          {
            selectButtonDescriptions[
              item as keyof typeof selectButtonDescriptions
            ]
          }
        </DescriptionText>
      )}
    </CustomTouchableOpacity>
  );
};

export default PreferenceButton;

const CustomTouchableOpacity = styled(TouchableOpacity)(
  ({
    isSelected,
    isDesktop,
    height,
  }: {
    isSelected: boolean;
    isDesktop: boolean;
    height: number;
  }) => ({
    cursor: 'pointer',
    borderColor: green,
    borderWidth: 1,
    borderRadius: 5,
    marginBottom: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: isSelected ? green : white,
    height,
    width: isDesktop ? 233 : '100%',
    paddingHorizontal: 15,
  }),
);

const Check = styled.Image({
  width: 20,
  height: 20,
  position: 'absolute',
  top: 7,
  left: 7,
});

const sharedTextStyles = css({
  fontWeight: 'regular',
  textAlign: 'center',
});

const CustomText = styled(LoraText)(
  ({ isDesktop, selected }: { isDesktop: boolean; selected: boolean }) => ({
    ...sharedTextStyles,
    textTransform: 'uppercase',
    color: selected ? white : green,
    fontSize: isDesktop ? 16 : 20,
    letterSpacing: 1.73,
  }),
);

const DescriptionText = styled(BaseText)(
  ({ selected }: { selected: boolean }) => ({
    ...sharedTextStyles,
    color: selected ? white : green,
    fontSize: 16,
    letterSpacing: -0.16,
  }),
);
